import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupsRoutingModule } from './groups-routing.module';
import { GroupsComponent } from './groups.component';
import { GroupCreationModalComponent } from './group-creation-modal/group-creation-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRippleModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { GroupsDetailsComponent } from './group-details/group-details.component';

import { GroupMetadataWidgetComponent } from './group-description-card/group-description-card.component';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { GroupAssessmentCreationModalComponent } from './group-assessment-creation-modal/group-assessment-creation-modal.component';
import { CandidateImportComponent } from './group-candidate-import-modal/candidate-import.component';

@NgModule({
  imports: [
    CommonModule,
    GroupsRoutingModule,
    FormsModule,
    MatFormFieldModule,
    MatRippleModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatInputModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    GroupsComponent,
    GroupCreationModalComponent,
    GroupsDetailsComponent,
    CandidateImportComponent,
    GroupMetadataWidgetComponent,
    GroupAssessmentCreationModalComponent,
  ],
})
export class GroupsModule {}
